export function Previous(currentSelected) {
  if (currentSelected !== 0) { return (currentSelected - 1); } else { return currentSelected }
}
export function Next(currentSelected) {
  if (currentSelected !== 8) { return (currentSelected + 1); } else { return currentSelected }
}